import { mobile } from "../../../mediaQueries";

const styles = (theme) => ({
  "@global": {
    ".MuiButton-root.Mui-disabled": {
      color: "white !important",
      backgroundColor: "#696969",
    },
  },
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    marginTop: "1.5rem",
  },
  doubleRow: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      flexDirection: "column",
    },
  },
  textArea: {
    width: "calc(100% - 10px)",
    alignSelf: "flex-start",
    padding: "0 10px 0 0",
    marginBottom: "-0.5rem",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      padding: "0",
      marginLeft: "-10px",
      width: "100%",
    },
  },
  p: {
    fontFamily: "Aktiv Grotesk",
    fontSize: "12px",
    alignSelf: "flex-start",
    margin: "0 0 0 10px",
    fontWeight: 500,
    color: "#101010",
    marginTop: ".5rem",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      marginTop: "1rem",
      color: "#575452 ",
    },
  },
  campi: {
    fontFamily: "Aktiv Grotesk",
    fontSize: "12px",
    alignSelf: "flex-start",
    margin: "0 0 0 10px",
    fontWeight: 500,
    color: "#101010",
    marginTop: ".5rem",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      marginTop: "10px",
      fontSize: "14px",
      color: "#575452 ",
    },
  },
  a: {
    fontFamily: "Aktiv Grotesk",
    fontSize: "12px",
    alignSelf: "flex-start",
    margin: "0",
    fontWeight: 500,
    color: "#101010",
  },
  submitBtn: {
    cursor: "none !important",

    color: "white",
    backgroundColor: "#0045EA",
    borderRadius: "0",
    fontFamily: "Aktiv Grotesk",
    padding: "12px 20px",
    textTransform: "none",
    marginTop: "2rem",
    "&:hover": {
      backgroundColor: "#0045EA",
    },
  },
});

export default styles;
